export const isEven = n => n % 2 === 0;
export const isOdd = n => n % 2 === 1;



/** WEBPACK FOOTER **
 ** ./src/lib/conditions.js
 **/